module.exports = __webpack_public_path__ + "img/comunicacao-icon.fbdea9da.png";